<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar v-if="closable">
      New Credit Card
    </template>
    <template v-slot:body>
      <payment-gateway
        ref="paymentGateway"
        compact
        only-new
        @card="listenCard"
      />
    </template>
    <template v-slot:actions>
      <gg-btn secondary v-if="closable" @click="close">
        Cancel
        <span class="visually-hidden text-lowercase">
            button
        </span>
      </gg-btn>
      <gg-btn primary :loading="loading" @click="addCreditCard">
        Add Credit Card
        <span class="visually-hidden text-lowercase">
            button
        </span>
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import PaymentGateway from '../Common/PaymentGateway'

export default {
  name: 'EditPaymentForm',
  provide () {
    return {
      $validator: this.$validator,
    }
  },
  components: {
    PaymentGateway
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    closable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    model: {
      cardnum: '',
      expdate: '',
      cardnum_cvv: ''
    },
    loading: false,
  }),
  methods: {
    ...mapActions(['getProfile', 'makecall', 'reportSuccess', 'reportError']),
    listenCard (card) {
      this.model = card
    },
    async addCreditCard () {
      try {
        const valid = await this.$refs.paymentGateway.validateForm()
        if (!valid) { return }

        this.loading = true
        const data = {
          method: 'creditcard_update',
          data: {
            slot: 'primary',
            cardnum: this.model.cardnum,
            cardexp: this.model.expdate.replace(/\//ig, '')
          }
        }
        const response = await this.makecall({ ...data })

        if (response.result === 'success') {
          await this.getProfile()
          this.$emit('cc-updated')
          this.reportSuccess(response.resultmsg)
        } else {
          this.reportError(response.resultmsg)
        }
        this.close()
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },

    close () {
      this.$refs.paymentGateway.clearForm()
      this.$emit('close')
    },
  },
}
</script>
